import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import LinkedInResultsPanel from "./LinkedInResultsPanel";

const LinkedInAIModal = ({
  isOpen,
  onClose,
  projectId,
  apiUrl,
  activeProfiles = [],
  onDiscardSuccess,
  loadingProfiles = false,
  fetchLinkedInProfiles,
}) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="advanced-filters-overlay"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          onClick={(e) => e.stopPropagation()}
        >
          <LinkedInResultsPanel
            projectId={projectId}
            apiUrl={apiUrl}
            activeProfiles={activeProfiles}
            onDiscardSuccess={onDiscardSuccess}
            loading={loadingProfiles}
            onClose={onClose}
            onRefresh={fetchLinkedInProfiles}
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LinkedInAIModal;
